// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2pK1S","title":"ClientInsurance_title__IrYEB","itemText":"ClientInsurance_itemText__3zyUz"};